/**
 * Singleton accessor for the one app-shell-level ListDrawer instance,
 * mirroring state/cartDrawer.ts's exact same plain-module-state style for
 * its own hand-off. Instantiated once in main.ts.
 */
import type { ListDrawer } from '../components/ListDrawer';

let instance: ListDrawer | null = null;

export function setListDrawer(drawer: ListDrawer): void {
  instance = drawer;
}

export function getListDrawer(): ListDrawer | null {
  return instance;
}
